module.exports = __webpack_public_path__ + "af5ec8af4e8cc0278ca21913de51e7b3.pdf";